var adManager = require('src/interlock/product/ads/ad-manager/ad-manager');
var asyncGptTempalte = require('./async-gpt-tag.html');
var responsiveToolkit = require('src/interlock/no-ui/utils/responsive-bootstrap-toolkit/responsive-bootstrap-toolkit');
var utilities = require('./async-gpt-tag-utilities.js');
var REFRESH_ZONES = require('src/interlock/product/ads/refresh-zones.js');

var breakpointCheck = utilities.breakpointCheck(responsiveToolkit);
var parseTargetingValues = utilities.parseTargetingValues;



function _init(elem, adUnit) {
    var genMarkup = !document.getElementById(adUnit.getContainerId());
    if(genMarkup){
        var markup = asyncGptTempalte({
            id: adUnit.getId(),
            containerId: adUnit.getContainerId()
        });

        $(markup).appendTo(elem);
    }
}


// AsyncGptTag CLASS DEFINITION
// =========================
var AsyncGptTag = function(element) {
    var self = this;
    self.$element = $(element);
    self.$baseValues = parseTargetingValues(element.data().targeting);
    self.$customValues = parseTargetingValues(element.data().customTargeting);
    self.$baseSizes = utilities.parseSize(self.$baseValues.adname);
    self.$refreshZone = utilities.parseZones(element.data().refreshZones);
    self.$moduleValue = element.data().moduleValue;
    var breakpoint = self.$baseValues.breakpoint;
    var deferOnAction = element.data().actionDefer;
    var correlator = element.data().correlator;

    function addUnit() {
        self.$adUnit = adManager.add(self.$refreshZone, function () {
            return self.getCustomValues();
        }, deferOnAction, correlator, function () {
            return self.getModuleValue();
        });
    }

    function handleDeferOnAction() {
        self.disabled = false;
        // attempt to render any ads that have deferOnAction or refresh zones that contain "viewport"
        // we can assume we want them to render if they are within the viewport.
        if(deferOnAction === REFRESH_ZONES.VIEWPORT
            || self.$refreshZone.indexOf(REFRESH_ZONES.VIEWPORT) > -1
            || self.$refreshZone.indexOf(REFRESH_ZONES.VIEWPORT_SLIDE > -1)) {
            // TODO: remove code duplication in if/else here for withinViewport
            if(utilities.withinViewport(self.$element, deferOnAction) && !self.disabled) {
                addUnit();
                adManager.renderSingleAd(self.$adUnit);
                self.disabled = true;
            } else {
                deferOnActionListener();
            }
        } else {
            deferOnActionListener();
        }
    }

    function deferOnActionListener() {
        $(window).on(deferOnAction, function(e) {
            if(utilities.withinViewport(self.$element, deferOnAction, e) && !self.disabled &&
                breakpointCheck(breakpoint)) {
                addUnit();
                adManager.renderSingleAd(self.$adUnit);
                self.disabled = true;
            }
        });
    }

    if (breakpoint) {
        if (breakpointCheck(breakpoint)) {
            if(deferOnAction){ //if we want ad to render immediately BUT ONLY if it is within viewport
                handleDeferOnAction();
            } else {
                addUnit();
            }
        }
    } else {
        if(deferOnAction){ //if we want ad to render immediately BUT ONLY if it is within viewport
            handleDeferOnAction();
        } else {
            addUnit();
        }
    }
    $(window).resize(
        responsiveToolkit.changed(function () {
            if(breakpointCheck(breakpoint) && adManager.exists(self.$adUnit)) {
                return false;
            }

            if(adManager.exists(self.$adUnit)) {
                adManager.remove(self.$adUnit);
            } else if(breakpointCheck(breakpoint)) {
                if(deferOnAction){ //if we want ad to render immediately BUT ONLY if it is within viewport
                    handleDeferOnAction();
                } else {
                    addUnit();
                }
                adManager.renderAds();
            }
        })
    );
};

AsyncGptTag.VERSION = '0.0.1';

AsyncGptTag.prototype.getCustomValues = function() {
    _init(this.$element, this.$adUnit);

    // TODO add breakpoint logic to determine appropriate sizes based on available real estate.

    var values = {
        sizes: this.$baseSizes,
        customValues: this.$customValues
    };

    $.extend(values, this.$baseValues);

    return values;
};

AsyncGptTag.prototype.getModuleValue = function() {
    return this.$moduleValue;
};


AsyncGptTag.prototype.destroy = function() {
    if (this.$adUnit) {
        adManager.remove(this.$adUnit);
        this.$element.remove();
    }
};


// DROPDOWN PLUGIN DEFINITION
// ==========================

function Plugin(config) {
    return this.each(function() {
        var $this = $(this);
        var data = $this.data('gpt.asyncGptTag');

        if (!data) {
            $this.data('gpt.asyncGptTag', (data = new AsyncGptTag($this)));
        } else if (typeof config === 'string') {
            if (data[config] === undefined) {
                throw new Error('No method named "' + config + '"');
            }
            data[config]();
        }
    });
}

$.fn.asyncGptTag = Plugin;
$.fn.asyncGptTag.Constructor = AsyncGptTag;



//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-tags/async-gpt-tag.js
// module id = 447
// module chunks = 36